<template>
  <div class="stulist">
    <div class="header">
      <span>已选课程{{ selectCourseNum }}</span>
      <Button
        type="primary"
        style="margin: 0 20px"
        icon="md-return-right"
        :disabled="selectDetailIdList.length === 0"
        @click="handleCreateStuList"
      >立即生成学生退款名单</Button>
      <p class="color-red">提示：如取消课程，请重新点击成学生退款名称!</p>
    </div>
    <div class="search">
      <div class="left">
        <Input
          v-model="stuName"
          placeholder="学生姓名"
          style="width: 300px; margin-right: 20px"
        ></Input>
        <Button type="primary" @click="handleGetNewStuList">搜索</Button>
      </div>
      <div class="right">
        <!-- <Button type="primary" icon="md-download" :disabled="selectDetailIdList.length===0||!hasCreatedList" @click="handleDownloadStuList">一键下载学生退款名单</Button> -->
      </div>
    </div>
    <div v-if="showDefault" class="default-page">
      <img :src="defaultImg">
      <p>请选择课程后，再点击生成学生退款名单</p>
    </div>
    <div v-else class="table-wrap">
      <Table
        :columns="columns"
        :loading="loadingStuList"
        :data="studentList"
        border
        max-height="500"
      >
        <template slot="stuInfo" slot-scope="{ row, index }">
          <div class="stuinfo-line">
            <div>{{ row.userName }}</div>
            <div>{{ row.className }}</div>
          </div>
        </template>
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.count"
          show-total
          show-sizer
          :current="pageInfo.page"
          :page-size="pageInfo.size"
          :page-size-opts="pageSizeOpts"
          show-elevator
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
    </div>
    <Row class="row row-line">
      <Col style="margin-right: 32px">退款笔数：<span class="color-blue">{{ refundInfo.refundNum }}</span>笔</Col>
      <Col style="margin-right: 32px">退款合计金额：<span class="color-red">{{
        refundInfo.refundAmount | filterMoney
      }}</span>元</Col>
      <Col class="color-red">注意：实际退款金额、实际退款笔数以审批为准！</Col>
    </Row>
    <!-- 下载的进度弹窗 -->
    <Modal
      v-model="percentModalShow"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelDownLoad"
    >
      <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelDownLoad">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import orderCenter from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import axios from 'axios';
export default {
  filters: {
    filterMoney(money) {
      if (money !== null && !isNaN(+money)) {
        return money / 100;
      } else {
        return '--';
      }
    }
  },
  props: {
    selectDetailIdList: {
      type: Array,
      default: () => []
    },
    dateList: {
      type: Array,
      default: () => []
    },
    searchData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      defaultImg: require('@/assets/img/empty2@2x.png'),
      stuName: '',
      studentList: [],
      columns: [],
      showDefault: true,
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      pageSizeOpts: [10, 20, 50, 100],
      refundInfo: {
        refundNum: '--',
        refundAmount: ''
      },
      concatList: [],
      detailIdList: [],
      hasCreatedList: false,
      searchDataForStu: {},
      loadingStuList: false,
      percentModalShow: false,
      downLoadPersent: 0, // 下载进度调
      percentInterVal: null,
      source: null
    };
  },
  computed: {
    selectCourseNum() {
      const selectCourseList = [];
      this.selectDetailIdList.forEach(item => {
        const y = selectCourseList.findIndex(x => {
          return x === item.classroomId;
        });
        if (y === -1) {
          selectCourseList.push(item.classroomId);
        }
      });
      return selectCourseList.length;
    }
  },
  watch: {
    searchData: {
      handler(newval, oldVal) {
        this.resetStuList();
      },
      deep: true
    },
    selectDetailIdList: {
      handler(newVal, oldVal) {
        if (newVal.length !== oldVal.length) {
          this.judgeShowModal();
        }
      },
      deep: true
    }
  },
  methods: {
    // 点击立即生成学生退款名单按钮
    async handleCreateStuList() {
      console.log(this.selectDetailIdList);
      if (this.selectDetailIdList.length === 0) {
        this.resetStuList();
        this.hasCreatedList = true;
        return false;
      }
      this.createStuColumn();
      this.detailIdList = this.selectDetailIdList.map(item => {
        return item.detailId;
      });
      this.searchDataForStu = { ...this.searchData, detailIdList: [...this.detailIdList] };
      this.getStudentList();
      this.getRefundNum();
      this.showDefault = false;
      this.hasCreatedList = true;
    },
    // 输入学生姓名点击搜索按钮
    handleGetNewStuList() {
      this.pageInfo.page = 1;
      this.searchDataForStu.stuName = this.stuName;
      this.getStudentList();
    },
    // 点击分页
    handlePageChange(page) {
      this.pageInfo.page = page;
      this.getStudentList();
    },
    // 点击跳转第几页
    handlePageSize(pageSize) {
      this.pageInfo.size = pageSize;
      this.getStudentList();
    },
    // 生成学生名单的表头
    createStuColumn() {
      this.columns = [
        {
          title: '学生信息',
          slot: 'stuInfo',
          align: 'center',
          className: 'stuinfo-line-box',
          width: 200,
          fixed: 'left',
          renderHeader: (h, { column, index }) => {
            return h('div', {
              class: 'header-box'
            }, [
              h('span', ['课程名称']),
              h('span', ['学生信息'])
            ]);
          }
        }
      ];
      this.concatList = [];
      this.selectDetailIdList.forEach(item => {
        const y = this.concatList.findIndex(x => {
          return x.key === item.classroomId;
        });
        if (y === -1) {
          this.concatList.push({
            title: item.classroomName,
            key: item.classroomId,
            align: 'center',
            minWidth: 180,
            render: (h, { row, column, index }) => {
              return h(
                'div', [
                  h('span', { class: 'money-text' }, [row[item.classroomId] ? row[item.classroomId].fee || row[item.classroomId].fee === 0 ? (row[item.classroomId].fee / 100) : '--' : '']),
                  h('span', [row[item.classroomId] ? '元【' + row[item.classroomId].num + '节】' : '--'])
                ]
              );
            }
          });
        }
      });
      this.columns = this.columns.concat(this.concatList);
      console.log(this.columns, '===4320432989889');
    },
    // 获取学生名单列表（分页）
    async getStudentList() {
      const params = { ...this.searchDataForStu, pageSize: this.pageInfo.size, pageNum: this.pageInfo.page };
      this.loadingStuList = true;
      try {
        const res = await orderCenter.getBatchRefundlistSignListApi(params);
        if (res.status === 200) {
          this.pageInfo.count = Number(res.message.total);
          this.studentList = res.message.list.map(item => {
            const obj = {
              userName: item.userName,
              className: item.className
            };
            item.signs.forEach(x => {
              if (obj[x.classroomId]) {
                obj[x.classroomId].fee += (+x.fee);
                obj[x.classroomId].num += 1;
              } else {
                obj[x.classroomId] = {
                  fee: +x.fee,
                  num: 1
                };
              }
            });
            return obj;
          });
        }
      } finally {
        this.loadingStuList = false;
      }
    },
    // 取消导出
    handleCancelDownLoad() {
      if (this.source) {
        this.source.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        // this.uploadPersent = 0;
        // this.canUploadFile = true;
        // this.modalShow = false;
        // this.uploadType === '';
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.downLoadPersent += 20;
      if (this.downLoadPersent >= 80) {
        clearInterval(this.percentInterVal);
      }
    },
    percentShow() {
      this.downLoadPersent = 0;
      this.percentInterVal = setInterval(this.percentShowFun, 500);
    },
    // 下载学生名单
    async handleDownloadStuList() {
      // return;
      const { stuName, ...params } = this.searchDataForStu;
      console.log(this.searchDataForStu, this.searchData, '===43243=====');
      params.detailIdList = [...this.detailIdList];
      params.pageNum = 1;
      params.pageSize = 1;
      params.dateList = [...this.dateList];
      console.log(params);
      this.percentModalShow = true;
      this.percentShow();
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const onDownloadProgress = progressEvent => {
        if (progressEvent.lengthComputable) {
          const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
          this.downLoadPersent = parseInt(val);
        }
      };
      // return;
      const res = await orderCenter.getExportOrderApi(params, this.source.token,
        onDownloadProgress);
      console.log(res, '======');
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          // this.$Message.success('导出成功');
          // clearInterval(this.percentInterVal);
          // this.downLoadPersent = 100;
          // setTimeout(() => {
          //   this.percentModalShow = false;
          //   this.showSelectExportModal = false;
          // }, 500);
          // downLoadByBlob(res);
          // return;
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
              this.showSelectExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
              this.showSelectExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.percentModalShow = false;
      }
    },
    // 获取学生的总信息
    async getRefundNum() {
      const params = { ...this.searchData, detailIdList: [...this.detailIdList], pageSize: this.pageInfo.size, pageNum: this.pageInfo.page };
      const res = await orderCenter.getBatchRefundCountSignApi(params);
      if (res.status === 200) {
        this.refundInfo = res.message;
      }
    },
    // 当点击完生成学生名单按钮之后，再修改选择的课程，需要展示弹窗
    judgeShowModal() {
      if (this.hasCreatedList) {
        this.handleCreateStuList();
        // this.$Modal.warning({
        //   title: '取消课程提示',
        //   content: '课程选中的取消后，需重新生成学生退款名单，是否立即生成？',
        //   okText: '立即生成学生退款名单',
        //   closable: true,
        //   onOk: () => {
        //     this.handleCreateStuList();
        //   }
        // });
      }
    },
    // 当重新点击搜索课程按钮的时候，需要置空当前学生名单
    resetStuList() {
      this.pageInfo = {
        page: 1,
        count: 0,
        size: 10
      };
      this.refundInfo = {
        refundNum: '--',
        refundAmount: ''
      };
      this.showDefault = true;
      this.hasCreatedList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.search {
  display: flex;
  justify-content: space-between;
}
.default-page {
  text-align: center;
  padding-top: 64px;
  margin-bottom: 48px;
  img {
    width: 200px;
    margin-bottom: 16px;
  }
}
.page-wrap {
  text-align: right;
  margin-top: 32px;
  margin-bottom: 48px;
}
.table-wrap {
  margin-top: 40px;
}
.row {
  font-size: 14px;
  margin-bottom: 16px;
}
/deep/.ivu-table-tbody,
/deep/.ivu-table-fixed-body {
  .stuinfo-line-box {
    div {
      height: 100%;
    }
  }
}
/deep/.ivu-table-tbody .money-text {
  color: red;
}
.stuinfo-line {
  display: flex;
  height: 100%;
  & > div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div:nth-of-type(1) {
    border-right: 1px solid #e8eaec;
  }
}
/deep/.ivu-table-header,
/deep/.ivu-table-fixed-header {
  th.stuinfo-line-box {
    height: 100px;
    padding: 0;
    div {
      width: 100%;
      height: 100%;
      padding: 0;
    }
    .header-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 300px;
        background-color: rgba(0, 0, 0, 0.1);
        display: block;
        -webkit-transform: rotate(-63.5deg);
        transform: rotate(-63.5deg);
        -webkit-transform-origin: top;
        transform-origin: top;
        overflow: hidden;
      }
      span {
        flex: 1;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
      }
      span:nth-of-type(1) {
        justify-content: flex-end;
        align-items: flex-start;
        position: relative;
      }
      span:nth-of-type(2) {
        justify-content: flex-start;
        align-items: flex-end;
      }
    }
  }
}
.row-line {
  font-weight: 600;
}
</style>
